import { isRunTime } from "./isRunTime";

const getQuery = (field = false) => {
  if (field) return getQueryField(field);
  if (!isRunTime()) return {};

  const urlParams = new URLSearchParams(window.location.search);
  const ret = {};

  for (const [key, value] of urlParams.entries()) {
    try {
      ret[key] = JSON.parse(value); // Parse JSON if possible
    } catch {
      ret[key] = value; // Keep as string if parsing fails
    }
  }

  return ret;
};

const getQueryField = (field) => {
  if (!isRunTime()) return null;
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(field);
  if (value) {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return null;
}

const setQuery = ({ key, value, pushState = false }) => {
  if (isRunTime() && key && value !== undefined) {
    // Use URLSearchParams but decode values to preserve readability
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    
    if (value !== null && value !== '' && String(value).trim() !== '') {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
    
    // Get the encoded query string and decode it for readability
    const encodedSearch = searchParams.toString();
    const decodedSearch = decodeURIComponent(encodedSearch);
    
    const newUrl = decodedSearch ? `?${decodedSearch}` : '';
    
    if (pushState) {
      window.history.pushState({}, "", `${url.pathname}${newUrl}`);
    } else {
      window.history.replaceState({}, "", `${url.pathname}${newUrl}`);
    }
  }
};

// same as resetQuery, but staying in the same page

const removeQueryParams = () => {
  if (isRunTime()) {
    const url = new URL(window.location);
    url.search = ""; // Clear the query strings
    window.history.replaceState({}, "", url.toString());
  }
};

const resetQuery = () => {
  if (isRunTime()) {
    window.history.replaceState({}, "", "/")
  }
}

export { getQuery, setQuery, resetQuery, removeQueryParams };
